






import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { PaymentMethod, PaymentSource } from '@/Payment/Enums';
import { HostedCheckoutRequest } from '@/Payment/HostedCheckoutRequest';
import PaymentSubmit from '@/Payment/PaymentMethods/PaymentSubmit.vue';
import UserMixin from '@/Shared/UserMixin';

const component = mixins(LocationBasedMixin, UserMixin).extend({
    name: 'DirectBootRelease',
    props: {
        transactionIdentifier: {
            type: String,
            required: true
        },
        hostedCheckoutRequest: {
            type: Object as () => HostedCheckoutRequest,
            required: true
        }
    },
    data() {
        return {
            i18nPrefix: 'payment.citationPayment.bootRelease.request',
            releaseCodes: [] as string[],
            requestingHold: false,
        };
    },
    computed: {
        entityUrls(): string {
            // Payment method doesn't matter for this call; just hardcoding it to something to make it work
            const path = `${this.location}/CitationPayments/${PaymentMethod.Card}/boots/releaseeligible`;
            const querySafeIdentifier = encodeURIComponent(this.transactionIdentifier);
            const query = `?transactionIdentifier=${querySafeIdentifier}`;
            return `${path}${query}`;
        }
    },
    mounted() {
        try {
            const submitter = new PaymentSubmit({
                propsData: {
                    request: this.hostedCheckoutRequest
                }
            });
            submitter.$props.request = this.hostedCheckoutRequest;
            submitter.$mount(this.$refs.slot as Element);
        }
        catch (e) {
            const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.holdRequestFailedTitle`);
            const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.holdRequestFailedMessage`);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });
            this.requestingHold = false;
            throw e;
        }
    }
});

export default component;
